
export const posiNotifProps = {
  title: "Success!",
  color: "green",
  autoClose: 5000,
};

export const negaNotifProps = {
  title: "Error",
  color: "red",
  autoClose: 5000,
}